/**
 * Modul Checkout Steps > Summary
 */

import {extend} from "../../../../shared/utils";

import SelectorEngine from '../../../../shared/dom/selector-engine';
import Data from "../../../../shared/dom/data";
import Manipulator from "../../../../shared/dom/manipulator";
import Slider from "../../../../shared/components/slider/slider";
import EventHandler from "../../../../shared/dom/event-handler";

const DEFAULTS = {
	autoHeight   : false,
	grabCursor   : true,
	keyboard: {
		enabled: true,
	},
	pagination: {
		dynamicBullets    : true,
		dynamicMainBullets: 1
	},
	slidesPerView: 'auto',
	spaceBetween : 0
};

// ------
// Private
// ------

const CHECKOUT_NAME = 'summary';

const NAME      = 'user-gallery';
const DATA_KEY  = `ifab.${NAME}`;
// const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY   = `.data-api`;

const renderSlider = (element, o) => {
	Slider.init(element, o);
};

/**
 * ´Media gallery´-Element initialisieren.
 *
 * @param {HTMLElement} element
 * @returns {HTMLElement}
 */
const render = (element) => {
	// Wurde Element schon initialisiert?
	if (Data.get(element, `${DATA_KEY}.initialized`)) {
		return element;
	}

	//
	// Slider
	//

	const slider = SelectorEngine.findOne(`[data-c="slider-${NAME}"]`, element);

	if (slider) {
		renderSlider(slider, extend({}, DEFAULTS, {
			pagination: {
				clickable: true,
				type     : 'custom'
			},
			on : {
				init: function(swiper) {
					renderCustomPagination(swiper);
				},
				afterInit: function(swiper) {
					changePaginationIndicator(swiper);
				},
				activeIndexChange: function(swiper) {
					changePaginationIndicator(swiper);
				}
			}
		}));
	}

	// Initialisierungsstatus setzen.
	Data.set(element, `${DATA_KEY}.initialized`, true);

	return element;
};

const renderCustomPagination = (swiper) => {
	const CLASS   = 'swiper-pagination-bullet';
	let bulletTpl = null;
	let userData  = getUserInitials(swiper.el);

	if(!userData) {
		return;
	}

	[...Array(userData.length)].forEach((_, i) => {
		bulletTpl = Manipulator.createElementFrom(`<span data-bind="tooltip" title="${userData.names[i]}" class="${CLASS} swiper-pagination-clickable" data-user${userData.valid[i]}>${userData.initials[i]}</span>`);

		Manipulator.elementAppend(bulletTpl, swiper.pagination.el);

		new bootstrap.Tooltip(bulletTpl);

		swiper.pagination.bullets.push(bulletTpl);
	});
};

const changePaginationIndicator = (swiper) => {
	for(const indexBullets in swiper.pagination.bullets) {
		if(swiper.pagination.bullets[indexBullets].classList.contains('swiper-pagination-bullet-active')) {
			swiper.pagination.bullets[indexBullets].classList.remove('swiper-pagination-bullet-active');
		}
	}

	for(const indexVisibleBullets of swiper.visibleSlidesIndexes) {
		if(!swiper.pagination.bullets[indexVisibleBullets].classList.contains('swiper-pagination-bullet-active')) {
			swiper.pagination.bullets[indexVisibleBullets].classList.add('swiper-pagination-bullet-active');
		}
	}
};

const getUserInitials = (slider) => {
	const COLLECTION = SelectorEngine.find('.user', slider);
	let userData = {};

	if(!COLLECTION.length) {
		return false;
	}

	userData = {
		length  : COLLECTION.length,
		initials: [],
		names   : [],
		valid	: []
	};

	for(const ELEMENT of COLLECTION) {
		userData.initials.push(Manipulator.getDataAttribute(ELEMENT, 'user-initials'));
		userData.names.push(Manipulator.getDataAttribute(ELEMENT, 'user-name'));
		userData.valid.push(Manipulator.getDataAttribute(ELEMENT, 'user-validation'));
	}

	return userData;
};

// ------
// Public
// ------

const init = () => {
	const COLLECTION = SelectorEngine.find(`[data-checkout="${CHECKOUT_NAME}"] [data-c="${NAME}"]`);

	if(!COLLECTION) {
		return;
	}

	for(const ELEMENT of COLLECTION) {
		render(ELEMENT);
	}
};

// ------
// Export
// ------

export default {
	init : init
};